// DOM helpers for keyboard navigation in the installed base Miller columns.
// All helpers operate relative to a column element (`.installed-base-column`),
// so search field and list can move focus without threading refs through the
// component tree. Lists are not virtualized, which makes DOM queries over the
// rendered items reliable.

export const ITEM_SELECTOR = '[data-ib-tree-item]';

export const getColumnEl = (el: Element | null): HTMLElement | null =>
    el?.closest<HTMLElement>('.installed-base-column') ?? null;

export const getColumnItems = (columnEl: HTMLElement | null): HTMLElement[] =>
    columnEl ? Array.from(columnEl.querySelectorAll<HTMLElement>(ITEM_SELECTOR)) : [];

export const focusItemAt = (
    columnEl: HTMLElement | null,
    index: number,
    options?: FocusOptions
): boolean => {
    const item = getColumnItems(columnEl)[index];
    if (!item) return false;
    item.focus(options);
    return true;
};

export const focusFirstItem = (columnEl: HTMLElement | null, options?: FocusOptions): boolean =>
    focusItemAt(columnEl, 0, options);

export const focusSearchInput = (columnEl: HTMLElement | null): boolean => {
    const input = columnEl?.querySelector<HTMLInputElement>('input[name="query"]');
    if (!input) return false;
    input.focus();
    return true;
};

export const focusSelectedItemInColumn = (columnEl: HTMLElement | null): boolean => {
    const item = columnEl?.querySelector<HTMLElement>(`${ITEM_SELECTOR}[data-selected="true"]`);
    if (!item) return false;
    item.focus();
    return true;
};

export const getAdjacentColumn = (
    columnEl: HTMLElement | null,
    direction: 'previous' | 'next'
): HTMLElement | null => {
    if (!columnEl) return null;
    const sibling = direction === 'previous' ? columnEl.previousElementSibling : columnEl.nextElementSibling;
    if (sibling instanceof HTMLElement && sibling.classList.contains('installed-base-column')) {
        return sibling;
    }
    return null;
};
